exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "header[data-v-147fc504]{display:block;background:#003f87;box-shadow:0 2px 3px 0 rgba(0,17,34,.4);font-size:2rem;position:fixed;top:0;width:100%;z-index:100}.navbar .navbar-brand[data-v-147fc504]{color:#fff;font-weight:400;letter-spacing:.07rem;padding-left:3.7rem;position:relative}.navbar .navbar-brand .logo[data-v-147fc504]{height:3rem;left:0;position:absolute;margin-top:-25px;top:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-147fc504","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/Header.vue
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-147fc504","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/Header.vue
// module chunks = 0